import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/user/remove/tenant.user.remove.mutation.gql"
import type {
  TenantUserRemoveMutation,
  TenantUserRemoveMutationVariables,
} from "@/v2-backoffice-client/tenant/user/remove/__types__/tenant.user.remove.mutation"

type Options = MutationHookOptions<
  TenantUserRemoveMutation,
  TenantUserRemoveMutationVariables
>

export function useTenantUserRemoveMutation(options?: Options) {
  return useMutation<
    TenantUserRemoveMutation,
    TenantUserRemoveMutationVariables
  >(mutation, options)
}
